import React, { Fragment, useState } from 'react'
import { map } from 'lodash';

import VcenterReport from "./VcenterReport";
import ClusterReport from "./ClusterReport";
import HostReport from "./HostReport";
import VMReport from "./VMReport";

const Tab = ({ name, openTab, setOpenTab }) => (
  <li className="nav-item">
    <a className={`nav-link ${openTab === name && 'active'}`} onClick={_ => setOpenTab(name)}>
      {name}
    </a>
  </li>
)

const vcentersTable = ({ vcenters, locations }) => <VcenterReport {...{ vcenters, locations }} />
const clustersTable = ({ clusters, locations }) => <ClusterReport {...{ clusters, locations }} />
const hostsTable = ({ hosts, locations }) => <HostReport {...{ hosts, locations }} />
const vmsTable = ({ vms, locations }) => <VMReport {...{ vms, locations }} />

const VcenterAssetReport = ({ data = {} }) => {
  const tabNames = ['vCenters', 'Clusters', 'Hosts', 'VMs']
  const [openTab, setOpenTab] = useState(tabNames[0])
  const ReportComponents = {
    vCenters: { call: _ => vcentersTable(data) },
    Clusters: { call: _ => clustersTable(data) },
    Hosts: { call: _ => hostsTable(data) },
    VMs: { call: _ => vmsTable(data) },
  }

  return (
    <Fragment>
      <ul className="nav nav-tabs">
        {map(tabNames, name => <Tab key={name} {...{ name, openTab, setOpenTab }} />)}
      </ul>

      {ReportComponents[openTab].call()}
    </Fragment>
  )
}

export default VcenterAssetReport
